import { PaymentMethodList } from "../../../paymentMethodList";

interface ICardView {
	fromIdentity?: boolean;
}
export const CardView = ({ fromIdentity = false }: ICardView) => {
	return <PaymentMethodList fromIdentity={fromIdentity} />;
};
